import axios from 'axios';
import root from 'window-or-global';
import Url from '../constants/Url';
import InviteActions from '../actions/InviteActions';

/**
 * InviteSource
 *
 */
const xhr = {
  getHeader: {
    'X-Requested-With': 'XMLHttpRequest',
    'X-EPIC-RETURN-JSON-IF-NO-AUTH': true,
  },
  postHeader: {
    'X-Requested-With': 'XMLHttpRequest',
  },
};

const InviteSource = {
  getCurrentInvites: {
    remote(state) {
      return axios.get(Url().INVITE.GETINVITES, {
        headers: xhr.getHeader,
      });
    },
    success: InviteActions.getCurrentInvitesSuccess,
    error: InviteActions.getCurrentInvitesFailure,
    shouldFetch() {
      return !root.__server_side_render;
    },
  },
  sendInvite: {
    remote(state, email) {
      return axios.post(
        Url().INVITE.SENDINVITE,
        {email},
        {
          headers: xhr.getHeader,
        }
      );
    },
    success: InviteActions.sendInviteSuccess,
    error: InviteActions.sendInviteFailure,
    shouldFetch() {
      return !root.__server_side_render;
    },
  },
};

export default InviteSource;
